import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as d, normalizeClass as s, createElementVNode as i } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const o = {
  name: "DtIconVisa",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(t).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ i("rect", {
  x: ".25",
  y: "3.75",
  width: "23.5",
  height: "16.5",
  rx: "1.75",
  fill: "#fff",
  stroke: "#E3E5E8",
  "stroke-width": ".5"
}, null, -1), h = /* @__PURE__ */ i("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.25 14.792H5.78l-1.103-4.333c-.053-.2-.164-.376-.327-.459A4.694 4.694 0 0 0 3 9.542v-.167h2.37c.327 0 .572.25.613.542l.573 3.125 1.47-3.667h1.43L7.25 14.792Zm3.024 0H8.886l1.144-5.417h1.39l-1.145 5.417Zm2.942-3.916c.041-.292.286-.459.573-.459.45-.042.94.042 1.348.25l.246-1.166a3.43 3.43 0 0 0-1.267-.251c-1.349 0-2.33.75-2.33 1.792 0 .792.695 1.208 1.186 1.458.53.25.735.417.694.667 0 .375-.409.541-.817.541a3.42 3.42 0 0 1-1.43-.333l-.246 1.167c.49.208 1.022.292 1.512.292 1.512.04 2.452-.709 2.452-1.834 0-1.417-1.92-1.5-1.92-2.124ZM20 14.792l-1.103-5.417h-1.185a.616.616 0 0 0-.573.417l-2.043 5h1.43l.286-.792h1.758l.163.792H20Zm-2.084-3.958.408 2.041H17.18l.736-2.041Z",
  fill: "#172B85"
}, null, -1), m = [
  _,
  h
];
function f(a, u, l, p, v, e) {
  return d(), r("svg", {
    "aria-label": l.ariaLabel,
    class: s([e.iconSizeClass, "d-icon d-icon--visa"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Visa",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, m, 10, c);
}
const x = /* @__PURE__ */ n(o, [["render", f]]);
export {
  x as default
};
//# sourceMappingURL=visa.js.map
